import React, { useMemo } from 'react';

import { DataSheet, Specification } from 'src/components/ProductDetail/utils/product-detail.types';
import { Tabs } from 'src/components/Tabs/Tabs';
import { Specifications } from 'src/components/ProductDetail/Specifications';
import { Overview } from 'src/components/ProductDetail/Overview';
import { DataSheets } from 'src/components/ProductDetail/DataSheets';

type ProductTabsProps = {
    benefits: string[];
    dataSheets: DataSheet[];
    description: string | null;
    specifications: Specification[];
};

const tabs = {
    information: (description: string | null, benefits: string[]) => {
        return {
            id: 'Information',
            title: 'Information',
            content: <Overview description={description} benefits={benefits} />,
        };
    },
    specifications: (specs: Specification[]) => {
        return {
            id: 'Specifications',
            title: 'Specifications',
            content: <Specifications specifications={specs} />,
        };
    },
    datasheets: (specs: DataSheet[]) => {
        return {
            id: 'Documents',
            title: 'Documents',
            content: <DataSheets dataSheets={specs} />,
        };
    },
};

export function ProductTabs(props: ProductTabsProps) {
    const specificTabs = useMemo(() => {
        const next = [tabs.information(props.description, props.benefits)];

        if (props.specifications.length > 0) {
            next.push(tabs.specifications(props.specifications));
        }

        if (props.dataSheets.length > 0) {
            next.push(tabs.datasheets(props.dataSheets));
        }

        return next;
    }, [props.description, props.benefits, props.specifications, props.dataSheets]);

    return <Tabs tabs={specificTabs} />;
}
